<template>
  <div>
    <a-card :title="pageTitle" style="margin: 20px">
      <template #extra>
        <a-button @click="goBack">返回</a-button>
      </template>

      <!-- 表单区域 -->
      <div class="formBox">
        <a-form-model
            ref="configForm"
            :colon="false"
            :label-col="{ span: 4 }"
            :model="formData"
            :rules="formRules"
            :wrapper-col="{ span: 14 }"
            label-align="left"
        >
          <a-form-model-item label="商户协议编号" prop="merchantNo">
            <a-input
                v-model.trim="formData.merchantNo"
                :disabled="isEdit"
                allow-clear
                class="short-input"
                placeholder="请输入商户协议编号（唯一，保存后不可变更）"
            />
          </a-form-model-item>

          <a-form-model-item label="商户协议名称" prop="merchantName">
            <a-input
                v-model.trim="formData.merchantName"
                allow-clear
                class="short-input"
                placeholder="请输入商户协议名称"
            />
          </a-form-model-item>

          <a-form-model-item label="付款方" prop="payerAccount">
            <WalletChooseDialog
                v-model="formData.payerName"
                :account-class="'0'"
                :open-account-class="true"
                class="short-input"
                @chooseDone="onPayerChosen"
            />
            <div v-if="formData.payerAccount" style="margin-top: 8px;">
              <WalletInfo :account-name="formData.payerName" :account-no="formData.payerAccount"/>
            </div>
            <div class="field-tip">须为系统内已登记的活期账户，支付协议将以该账户登记（OTC-TRADE 协议）</div>
          </a-form-model-item>

          <a-form-model-item label="收款账户" prop="payeeAccount">
            <WalletChooseDialog
                v-model="payeeChooseShowName"
                :account-class="'0'"
                :open-account-class="true"
                class="short-input"
                @chooseDone="onPayeeChosen"
            />
            <div v-if="formData.payeeAccount" style="margin-top: 8px;">
              <WalletInfo :account-name="formData.payeeName" :account-no="formData.payeeAccount"/>
            </div>
            <div class="field-tip">收款方，订单金额扣除服务费后全额到账该账户。系统内账户点上方【选择】带出账号/户名；系统外账户直接手动录入账号，并在下方填写户名与收款行。</div>
          </a-form-model-item>



          <a-form-model-item label="默认支付摘要">
            <a-input
                v-model.trim="formData.defaultPaySummary"
                allow-clear
                class="short-input"
                placeholder="银行转账附言，下单时可覆盖"
            />
          </a-form-model-item>

          <a-form-model-item label="备注">
            <a-input
                v-model.trim="formData.remark"
                allow-clear
                class="short-input"
                placeholder="选填"
            />
          </a-form-model-item>

          <!-- 服务费规则区域 -->
          <a-form-model-item label="服务费规则">
            <a-alert
                message="服务费从订单总额中扣收：比例 = 总额 × 比例%，固定 = 固定金额；到账金额 = 总额 − 服务费合计。可不配置，即无服务费。"
                show-icon
                style="margin-bottom: 12px;"
                type="info"
            />
            <a-table
                :columns="feeRuleColumns"
                :data-source="formData.feeRules"
                :pagination="false"
                :row-key="(record, index) => index"
                bordered
                size="small"
                tableLayout="fixed"
            >
              <template slot="feeAccount" slot-scope="text, record, index">
                <WalletChooseDialog
                    v-model="record.feeName"
                    :account-class="'0'"
                    :open-account-class="true"
                    style="display: inline-block;"
                    @chooseDone="(wallet) => onFeeAccountChosen(wallet, index)"
                />
                <div v-if="record.feeAccount" style="margin-top: 4px; font-size: 12px; color: #999;">
                  {{ record.feeAccount }}
                </div>
              </template>
              <template slot="feeType" slot-scope="text, record">
                <a-select v-model="record.feeType" placeholder="类型" style="width: 100%">
                  <a-select-option :value="1">比例(%)</a-select-option>
                  <a-select-option :value="2">固定金额</a-select-option>
                </a-select>
              </template>
              <template slot="feeValue" slot-scope="text, record">
                <a-input-number
                    v-model="record.feeValue"
                    :max="record.feeType === 1 ? 100 : undefined"
                    :min="0.01"
                    :precision="2"
                    :step="record.feeType === 1 ? 0.01 : 1"
                    placeholder="0.01"
                    style="width: 100%"
                />
              </template>
              <template slot="feeSummary" slot-scope="text, record">
                <a-input
                    v-model="record.feeSummary"
                    placeholder="手续费摘要（选填）"
                    size="small"
                    style="width: 100%"
                />
              </template>
              <template slot="action" slot-scope="text, record, index">
                <a-button
                    icon="delete"
                    style="color: #ff4d4f;"
                    type="link"
                    @click="removeFeeRule(index)"
                >删除
                </a-button>
              </template>
            </a-table>
            <div style="margin-top: 8px;">
              <a-button icon="plus" style="width: 100%;" type="dashed" @click="addFeeRule">新增服务费规则</a-button>
            </div>
          </a-form-model-item>

          <!-- 按钮区域 -->
          <a-form-model-item :wrapper-col="{ span: 14, offset: 4 }">
            <a-button @click="goBack">取消</a-button>
            <a-button :loading="confirmLoading" style="margin-left: 8px;" type="primary" @click="handleSave">
              {{ isEdit ? '保存' : '新增' }}
            </a-button>
          </a-form-model-item>
        </a-form-model>
      </div>
    </a-card>
  </div>
</template>

<script>
import {message} from "ant-design-vue";
import WalletChooseDialog from "@/view/components/ChooseDialog/WalletChooseDialog.vue";
import WalletInfo from "@/view/components/WalletInfo.vue";
import BankSearch from "@/view/components/BankSearch.vue";

export default {
  name: 'PayAgrMerchantConfigCreate',
  components: {WalletInfo, WalletChooseDialog, BankSearch},
  data() {
    return {
      mode: 'add',
      formData: {
        id: null,
        merchantNo: '',
        merchantName: '',
        payerAccount: '',
        payerName: '',
        payeeAccount: '',
        payeeName: '',
        payeeBankNo: "313338707013",
        payeeBankName: "浙江稠州商业银行",
        defaultPaySummary: '',
        remark: '',
        feeRules: [],
      },
      formRules: {
        merchantNo: [{required: true, message: '请输入商户协议编号', trigger: 'blur'}],
        merchantName: [{required: true, message: '请输入商户协议名称', trigger: 'blur'}],
        payerAccount: [{required: true, message: '请选择付款方', trigger: 'change'}],
        payeeAccount: [{required: true, message: '请输入收款账户', trigger: 'blur'}],
        payeeName: [{required: true, message: '请输入收款户名', trigger: 'blur'}],
        payeeBankNo: [{required: true, message: '请选择或输入收款行号', trigger: 'change'}],
      },
      feeRuleColumns: [
        {title: '收款账户', dataIndex: 'feeAccount', width: 180, scopedSlots: {customRender: 'feeAccount'}},
        {title: '类型', dataIndex: 'feeType', width: 110, scopedSlots: {customRender: 'feeType'}},
        {title: '费率/金额', dataIndex: 'feeValue', width: 110, scopedSlots: {customRender: 'feeValue'}},
        {title: '摘要', dataIndex: 'feeSummary', width: 150, scopedSlots: {customRender: 'feeSummary'}},
        {title: '操作', key: 'action', width: 80, scopedSlots: {customRender: 'action'}},
      ],
      payeeChooseShowName: '',
      confirmLoading: false,
    };
  },
  computed: {
    isEdit() {
      return this.mode === 'edit';
    },
    pageTitle() {
      return this.isEdit ? '编辑商户协议（仅已拒绝状态可编辑）' : '新增商户协议';
    },
  },
  mounted() {
    this.mode = this.$route.query.mode || 'add';
    if (this.$route.query.configId) {
      this.loadDetail(this.$route.query.configId);
    }
  },
  methods: {
    async loadDetail(configId) {
      try {
        const res = await this.api.getPayAgrConfigDetail(configId);
        if (res.code === 200 && res.data) {
          const d = res.data;
          this.formData = {
            id: d.configId,
            merchantNo: d.merchantNo || '',
            merchantName: d.merchantName || '',
            payerAccount: d.payerAccount || '',
            payerName: d.payerName || '',
            payeeAccount: d.payeeAccount || '',
            payeeName: d.payeeName || '',
            payeeBankNo: d.payeeBankNo || '',
            payeeBankName: d.payeeBankName || '',
            defaultPaySummary: d.defaultPaySummary || '',
            remark: d.remark || '',
            feeRules: (d.feeRules || []).map(r => ({
              feeAccount: r.feeAccount || '',
              feeName: r.feeName || '',
              feeBankNo: r.feeBankNo || '',
              feeBankName: r.feeBankName || '',
              feeType: r.feeType,
              feeValue: r.feeValue != null ? Number(r.feeValue) : null,
              feeSummary: r.feeSummary || '',
            })),
          };
          this.payeeChooseShowName = d.payeeName || '';
        } else {
          message.warning(res.info || "获取详情失败");
        }
      } catch (error) {
        console.error("获取详情失败:", error);
        message.error("获取详情失败");
      }
    },

    onPayerChosen(wallet) {
      this.formData.payerAccount = wallet.accountNo;
      this.formData.payerName = wallet.accountName;
      if (!this.formData.merchantName) {
        this.formData.merchantName = wallet.accountName;
      }
      this.$nextTick(() => {
        this.$refs.configForm && this.$refs.configForm.validateField('payerAccount');
      });
    },

    onPayeeChosen(wallet) {
      this.formData.payeeAccount = wallet.accountNo;
      this.formData.payeeName = wallet.accountName;
      this.payeeChooseShowName = wallet.accountName;
      this.$nextTick(() => {
        this.$refs.configForm && this.$refs.configForm.validateField('payeeAccount');
        this.$refs.configForm && this.$refs.configForm.validateField('payeeName');
      });
    },

    onFeeAccountChosen(wallet, index) {
      this.formData.feeRules[index].feeAccount = wallet.accountNo;
      this.formData.feeRules[index].feeName = wallet.accountName;
    },

    addFeeRule() {
      this.formData.feeRules.push({
        feeAccount: '',
        feeName: '',
        feeBankNo: '313338707013',
        feeBankName: '浙江稠州商业银行股份有限公司',
        feeType: 1,
        feeValue: null,
        feeSummary: '',
      });
    },

    removeFeeRule(index) {
      this.formData.feeRules.splice(index, 1);
    },

    /** 前端预校验服务费规则完整性（后端 saveConfig 会再次校验） */
    validateFeeRules() {
      const seen = new Set();
      for (let i = 0; i < this.formData.feeRules.length; i++) {
        const r = this.formData.feeRules[i];
        const rowNo = `第${i + 1}条服务费规则`;
        if (!r.feeAccount) {
          message.warning(`${rowNo}：请选择收款账户`);
          return false;
        }
        if (!r.feeName) {
          message.warning(`${rowNo}：收款户名为空`);
          return false;
        }
        if (!r.feeBankNo || !r.feeBankName) {
          message.warning(`${rowNo}：请选择或输入收款行号/行名`);
          return false;
        }
        if (r.feeType !== 1 && r.feeType !== 2) {
          message.warning(`${rowNo}：请选择类型`);
          return false;
        }
        if (r.feeValue == null || Number(r.feeValue) <= 0) {
          message.warning(`${rowNo}：费率/金额须大于0`);
          return false;
        }
        if (r.feeType === 1 && Number(r.feeValue) > 100) {
          message.warning(`${rowNo}：比例不能超过100%`);
          return false;
        }
        if (r.feeAccount === this.formData.payerAccount) {
          message.warning(`${rowNo}：收款账户不能与付款方相同`);
          return false;
        }
        if (r.feeAccount === this.formData.payeeAccount) {
          message.warning(`${rowNo}：收款账户不能与收款方相同`);
          return false;
        }
        if (seen.has(r.feeAccount)) {
          message.warning(`${rowNo}：收款账户 ${r.feeAccount} 重复`);
          return false;
        }
        seen.add(r.feeAccount);
      }
      return true;
    },

    async handleSave() {
      this.$refs.configForm.validate(async (valid) => {
        if (!valid) return;
        if (this.formData.payeeAccount === this.formData.payerAccount) {
          message.warning('收款账户不能与付款方相同');
          return;
        }
        if (!this.validateFeeRules()) return;
        this.confirmLoading = true;
        try {
          const submitData = {
            ...this.formData,
            feeRules: this.formData.feeRules.map((r, index) => ({...r, sortOrder: index + 1})),
          };
          const res = await this.api.createPayAgrConfig(submitData);
          if (res.code === 200) {
            message.success(this.isEdit ? '保存成功，已重新提交审批' : '新增成功（状态：待审批）');
            this.$router.push('/pay-agr/merchantConfig');
          } else {
            message.error(res.info || (this.isEdit ? '保存失败' : '新增失败'));
          }
        } catch (error) {
          console.error("保存失败:", error);
          message.error(this.isEdit ? '保存失败' : '新增失败');
        } finally {
          this.confirmLoading = false;
        }
      });
    },

    goBack() {
      this.$router.push('/pay-agr/merchantConfig');
    },
  },
};
</script>

<style lang="less" scoped>
.formBox {
  padding: 20px;
}

.short-input {
  width: 300px !important;
}

.field-tip {
  margin-top: 4px;
  font-size: 12px;
  color: #999;
  line-height: 1.6;
}

/deep/ .ant-form-item {
  margin-bottom: 16px;
}
</style>
